<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划名称">
              <global-select
                :value.sync="queryParams.planName"
                requestApi="/scp/scpMrpPlans/planNameBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ noPlanType: 105, dataType: 1 }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划类型">
              <global-select
                :value.sync="queryParams.planType"
                :selectData="planTypeList"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiScpMrpPlansNewExport" ref="download" />
      <a-button @click="$refs.createModal.show()" type="primary" v-hasPermi="['scp:scpMrpPlans:add']">新建</a-button>
      <a-button @click="handleExport" v-hasPermi="['scp:scpMrpPlans:export']">导出</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <!-- <a-table
          ref="table"
          :columns="columns"
          :loading="pageParams.tableLoading"
          :data-source="tableList"
          :pagination="false"
          row-key="id"
          :scroll="{ x: 1200 }"
        >
          <div
            v-for="item in columns"
            :slot="item.dataIndex"
            slot-scope="text, record"
            :key="item.dataIndex"
          >
            <span v-if="item.dataIndex === 'operation'">
              <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)" v-hasPermi="['scp:scpMrpPlans:edit']">编辑</a>
              <a v-if="!isEdit || currentId !== record.id" @click="handleDelete(record)" v-hasPermi="['scp:scpMrpPlans:remove']" class="ml10">删除</a>
            </span>
            <span v-else-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
            <span v-else-if="item.type === 'routerLink'">
              <a @click="handleDetail(record)">{{ text }}</a>
            </span>
            <span v-else>{{ text }}</span>
          </div>
        </a-table> -->

        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.MRP_PLAN_NAME_LIST, // 表格方案配置唯一值
              }"
        >
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a v-if="!isEdit || currentId !== text.record.id" @click="handleEdit(text.record)" v-hasPermi="['scp:scpMrpPlans:edit']">编辑</a>
                <a v-if="!isEdit || currentId !== text.record.id" @click="handleDelete(text.record)" v-hasPermi="['scp:scpMrpPlans:remove']" class="ml10">删除</a>
              </span>
              <span v-else-if="item.type === 'text'">{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else-if="item.type === 'routerLink'">
                <a @click="handleDetail(text.record)">{{ text.text }}</a>
              </span>
              <span v-else>{{ text.text }}</span>
            </div>
          </template>
        </ls-api-table>
        <!-- 底部分页按钮 -->
        <!-- <Page ref="page" :pageParams.sync="pageParams" @getList="getList" /> -->
        <mrp-plan-name-add
          ref="createModal"
          :planTypeList="planTypeList"
          @handle-success="handleOk"
        />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { apiScpMrpPlansDelete, apiScpMrpPlansList, apiScpMrpPlansNewExport } from '@/api/scp/planSetting/mrpPlanName'
import MrpPlanNameAdd from './components/mrp-plan-name-add'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'

export default {
  name: 'MrpPlanName',
  components: {
    DownloadModal,
    MrpPlanNameAdd
  },
  data () {
    return {
      apiScpMrpPlansNewExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiScpMrpPlansList, true),
        pageCurrent: true
      },
      isEdit: false,
      currentId: "",
      pageParams: {
        automatic: true,
        pageUrl: '/scp/scpMrpPlans/list',
        tableLoading: false
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        planName: undefined,
        planType: undefined
      },
      // 表格数据
      tableList: [],
      // 表格字段
      columns: [
        {
          title: '计划名称',
          dataIndex: 'planName',
          scopedSlots: { customRender: 'planName' },
          align: 'center',
          type: "routerLink"
        },
        {
          title: '说明',
          dataIndex: 'description',
          ellipsis: true,
          width: 200,
          align: 'center'
        },
        {
          title: '计划类型',
          dataIndex: 'planTypeName',
          align: 'center'
        },
        {
          title: '失效时间',
          dataIndex: 'disableDate',
          scopedSlots: { customRender: 'disableDate' },
          width: 160,
          align: 'center',
          type: "text"
        },
        {
          title: '更新人',
          dataIndex: 'updateName',
          align: 'center'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 160,
          align: 'center',
          type: "text"
        },
        {
          title: '创建人',
          dataIndex: 'createName',
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 160,
          align: 'center',
          type: "text"
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      },
      planTypeList: [] // 计划类型
    }
  },
  created () {
    this.getLookupList('SCP_PLAN_TYPES', 'planTypeList')
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    // 删除
    handleDelete (row) {
      if (!row.disableDate) {
        this.$error({
          content: '错误：该计划未失效，删除计划前需先失效计划。',
          okText: "确定"
        })
        return
      }
      const self = this
      this.$confirm({
        title: '你确定要删除这行内容吗?',
        content: "注：删除计划将删除相关计划结果数据",
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          apiScpMrpPlansDelete(row.id).then((response) => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    // 计划名称-跳转详情
    handleDetail (record) {
      this.$router.push({ name: `mrp-plan-name-detail`, query: { status: "look", row: JSON.stringify(record) } })
    },
     // 表单搜索
     onSearch () {
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
      this.isEdit = false
    },
    // 编辑
    handleEdit (record) {
      this.$router.push({ name: `mrp-plan-name-detail`, query: { status: "edit", row: JSON.stringify(record) } })
    },
    /** 查询列表 */
    getList (data) {
      this.tableList = data
      this.isEdit = false
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        planName: undefined,
        planType: undefined
      }
      this.handleQuery()
    },
    setArray (arr) {
      return this[arr]
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导出按钮操作 */
    handleExport () {
      const params = this.queryParams
      this.$refs.download.openModal(params)
      // this.download('scp/scpMrpPlans/export', {
      //   ...this.queryParams
      // }, `MRP计划名称_${new Date().getTime()}.xlsx`)
    },
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        if (type === "SCP_PLAN_TYPES") {
          this[arr] = response.rows.filter((item) => item.lookupCode !== "105")
        } else {
          this[arr] = response.rows
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
.page-header-content{
  /deep/.ant-select{
    width: 150px;
  }
}
</style>
